import { Injectable } from "@angular/core";
import { ApiService } from "@core/services/api.service";
import { ApiServiceHolder } from "@core/utils/api-service-holder";
import { Observable } from "rxjs";
import { Group, Page, PageText } from "../interfaces/pages.interface";

@Injectable({
    providedIn: 'root'
  })
  export class PagesService {
  
    constructor(private _api: ApiService,
    ) {
    }
  
    getPagesName(): Observable<Page[]> {
      return this._api.request(ApiServiceHolder.pagetext.getPagesName());
    }

    getByPk(idPage: number, idLanguage: number): Observable<PageText> {
      return this._api.request(ApiServiceHolder.pagetext.getByPk(idPage, idLanguage));
    }

    getGroups(): Observable<Group[]> {
      return this._api.request(ApiServiceHolder.pagetext.getGroups());
    }

    save(item: PageText): Observable<PageText[]> {
      return this._api.request(ApiServiceHolder.pagetext.save(item));
    }
    
  }
  